import DrawerPanel from './DrawerPanel';

export default DrawerPanel;



// WEBPACK FOOTER //
// ./src/views/components/Common/DrawerPanel/index.js